module.exports = __webpack_public_path__ + "img/home-hero_cn.5f0587e.png";